import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "../../../Header";
import { ToastContainer } from "react-toastify";
import { BiArrowBack, BiPencil, BiTrash, BiPlus, BiX } from "react-icons/bi";
import useFetchGet from "../hooks/useFetchGet";
import useFetchPost from "../hooks/useFetchPost";
import AsyncSelect from "react-select/async";
import DatePicker from "rsuite/DatePicker";
import InputPicker from "rsuite/InputPicker";
import SelectPicker from "rsuite/SelectPicker";
import CheckPicker from "rsuite/CheckPicker";
import SpinnerIcon from "@rsuite/icons/legacy/Spinner";
import AutoComplete from "rsuite/AutoComplete";
import Toggle from "rsuite/Toggle";
import "rsuite/CheckPicker/styles/index.css";
// import "rsuite/dist/rsuite.min.css";
import "../../../assets/css/rsuite.css";
import moment from "moment";
import { toast, Bounce } from "react-toastify";
import Cookies from "js-cookie";
import Autocomplete from '../../AutoComplete.js'

import { useHistory, useParams } from "react-router-dom";
const currentUnixTime = new Date().toLocaleDateString("en-CA");
const dealStates = ["Warm", "Hot", "Cold"].map((item) => ({ label: item, value: item }));
const AddDeal = () => {
	const { fetchData } = useFetchGet();
	const { fetchPostData } = useFetchPost();
	const history = useHistory();
	//const deal_uuid = match.params.deal_uuid;
	const { deal_uuid } = useParams();
	const [dealUuid, setDealUuid] = useState(deal_uuid);
	const [isEdit, setIsEdit] = useState(false);
	const [customerData, setCustomerData] = useState([]);
	const [customerSearchValue, setCustomerSearchValue] = useState("");

	const [productData, setProductData] = useState([]);
	const [stateData, setStateData] = useState([]);
	const [customerLoading, setCustomerLoading] = useState(false);
	const [stateLoading, setStateLoading] = useState(false);

	//necessory
	const [inputValue, setInputValue] = useState({
		customer_tattle_uuid: "",
		product: [],
		deal_name: "",
		deal_value: "",
		deal_state: "",
		deal_description: "",
		deal_status: true,
	});
	const [rows, setRows] = useState([
		{
			milestone_sl_no: 1,
			milestone_desc: "",
			milestone_amount: "",
			milestone_due: null,
			milestone_status: "Draft",
			isEditable: false,
		},
	]);
	const [tepDates, setTepDates] = useState({});
	const [isSaving, setIsSaving] = useState(false);
	const [isDisable, setIsDisable] = useState(false);
	const [error, setError] = useState({});
	
	const timerRef = useRef(null);

	useEffect(() => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}

		timerRef.current = setTimeout(() => {
			getCustomers(customerSearchValue);
		}, 1000);
	}, [customerSearchValue])

	const getCustomers = async (keyword) => {
		let retData = [];

		if (!keyword) {
			setCustomerLoading(false);
			setCustomerData([]);
			return;
		}

		if (keyword.trim().length < 1) {
			setCustomerLoading(false);
			setCustomerData([]);
			return;
		}

		setCustomerLoading(true);
		try {
			let responseData;

			if (keyword.trim().length >= 1) {
				responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/get-customer-list?keyword=${keyword}`);
			} else {
				responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/get-customer-list`);
			}

			if (responseData.code == 200) {
				retData = responseData.data;
				setCustomerLoading(false);
			} else {
				setCustomerLoading(false);
			}
			
			const filteredData = retData.map((item) => ({
				label: item.company_name,
				value: item.customer_tattle_uuid,
			}));
			setCustomerData(filteredData);
		} catch (error) {
			setCustomerLoading(false);
			setCustomerData([]);
			console.error("Error:", error);
		}
	};

	const getProduct = async () => {
		try {
			//DLOa1fdPDY9LN7RYOIyBhMKb161NCSSq
			const responseProductData = await fetchData(`${process.env.REACT_APP_CRM}/crm/product/list`);
			//console.log("ProductList", responseProductData);
			setProductData(responseProductData);
		} catch (error) {
			console.error("Error:", error);
		}
	};
	const getProducts = async () => {
		if (inputValue.customer_tattle_uuid != "" || inputValue.customer_tattle_uuid.length >= 1) {
			try {
				const responseData = await fetchData(
					`${process.env.REACT_APP_CRM}/crm/get-product-list/${inputValue.customer_tattle_uuid}`
				);
				if (responseData.code == 200) {
					setProductData(responseData.data);
				}
			} catch (error) {
				console.error("Error:", error);
			}
		}
	};
	const getDealState = async () => {
		setStateLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/get-deal-state-list`);
			if (responseData.code == 200) {
				setStateData(responseData.data);
				setStateLoading(false);
			}
		} catch (error) {
			setStateLoading(false);
			console.error("Error:", error);
		}
	};

	// useEffect(() => {
	// 	getProducts();
	// }, [inputValue.customer_id]);

	const getDealDetails = async () => {
		const requestBody = {
			deal_uuid: dealUuid,
		};
		let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/deal-detail";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, requestBody, true);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}
		if (responseData && responseData.code == 200) {
			const data = responseData.data;
			document.title = `Intranet | ${data.deal_name}`;
			// getCustomers(data.customer_id);
			setInputValue({
				deal_id: data.deal_id,
				deal_uuid: data.deal_uuid,
				customer_tattle_uuid: data.customer_tattle_uuid,
				product: data.product,
				deal_name: data.deal_name,
				deal_value: data.deal_value,
				deal_state: data.deal_state,
				deal_description: data.deal_description,
				deal_status: data.deal_status,
			});

			// if (data.customer_tattle_uuid) {
			// 	await getCustomers(data.customer_tattle_uuid);
			// }
			if (data.customer_tattle_uuid && data.company_name) {
				setCustomerData([
					{
						customer_tattle_uuid: data.customer_tattle_uuid,
						company_name: data.company_name
					}
				]);
				setCustomerSearchValue(data.company_name);
			}

			const formattedMilestones = data.milestones
				? data.milestones.map((milestone) => ({
					milestone_id: milestone.milestone_id,
					milestone_uuid: milestone.milestone_uuid,
					milestone_sl_no: milestone.milestone_sl_no,
					milestone_desc: milestone.milestone_desc,
					milestone_amount: milestone.milestone_amount,
					milestone_due: new Date(milestone.milestone_due * 1000),
					milestone_status: milestone.milestone_status,
					//milestone_status_show:
					//currentUnixTime > milestone.milestone_due ? "Overdue" : milestone.milestone_status,
					milestone_status_temp: milestone.milestone_status,
					milestone_amount_temp: milestone.milestone_amount,
					isEditable: true,
				}))
				: [];

			setRows(formattedMilestones);
		}
	};

	useEffect(() => {
		getProduct();
		if (dealUuid) {
			getDealDetails();
			//getCustomers();
			getDealState();
			setIsDisable(true);
			setIsEdit(true);
			document.title = `Intranet | Edit Deal`;
		} else {
			document.title = "Intranet | Add Deal";
			//getCustomers();
			setIsDisable(false);
			setIsEdit(false);
		}
	}, [dealUuid]);

	// useEffect(() => {
	// 	if (inputValue) {
	// 		getCustomers(customerKeyword);
	// 	}
	// }, [customerKeyword]);

	const handleCutomerChange = (item) => {
		if (!item) {
			setCustomerSearchValue("");	
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				customer_tattle_uuid: "",
			}));
			return;		
		}
		setCustomerSearchValue(item.label)
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			customer_tattle_uuid: item.value,
		}));
	}

	const handleSelectChange = (name) => (value) => {
		if (name == "customer_tattle_uuid") {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				customer_tattle_uuid: value.value, // Update inputValue with the selected values
			}));
		} else {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				[name]: value, // Update inputValue with the selected values
			}));
		}

		let validationErrors = {};
		// if (name == "customer_id" && value.valu != "") {
		// 	validationErrors.customer_id = "";
		// 	document.querySelector(".customer-id").querySelector(`.css-1pahdxg-control`).style.borderColor = "";
		// }
		if (name == "product_key") {
			validationErrors.product_key = "";
			document.querySelector(".product-key").querySelector(`.rs-picker-toggle`).style.borderColor = "";
		}
		if (name == "deal_state") {
			validationErrors.deal_state = "";
			document.querySelector(".deal-state").querySelector(`.rs-picker-toggle`).style.borderColor = "";
		}
		setError(validationErrors);
	};

	const handleDealInputChange = (event) => {
		const { name, value } = event.target;
		let formattedValue = value;

		if (name === "deal_value") {
			// Prevent non-numeric characters except a single dot
			formattedValue = formattedValue.replace(/[^0-9.]/g, '');

			// Ensure only one dot is present
			const parts = formattedValue.split('.');
			if (parts.length > 2) {
				formattedValue = parts[0] + '.' + parts.slice(1).join('');
			}

			// Restrict to two decimal places
			if (parts.length === 2 && parts[1].length > 2) {
				formattedValue = parts[0] + '.' + parts[1].slice(0, 2);
			}

			// Prevent leading dot (convert ".5" → "0.5")
			if (formattedValue.startsWith('.')) {
				formattedValue = '0' + formattedValue;
			}
		}

		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: formattedValue, // Update inputValue with the formatted value
		}));

		let validationErrors = {};
		let totalMilestoneAmount;
		let hasError = false;

		if (name === "deal_value") {
			const updatedRows = [...rows];
			totalMilestoneAmount = updatedRows.reduce((sum, milestone) => {
				return sum + Number(milestone.milestone_amount);
			}, 0);

			if (Number(formattedValue) === 0 || formattedValue === '') {
				validationErrors.deal_value = "Enter Deal Value";
				document.querySelector(".deal-value").style.borderColor = "red";
				hasError = true;
			} else {
				validationErrors.deal_value = "";
				document.querySelector(".deal-value").style.borderColor = "";
			}
		}

		if (name === "deal_name") {
			if (!value.trim()) {
				validationErrors.deal_name = "Enter Deal Name";
				document.querySelector(".deal-name").style.borderColor = "red";
			} else if (value.trim().length > 100) {
				validationErrors.deal_name = "Deal Name Exceeds 100 Characters.";
				document.querySelector(".deal-name").style.borderColor = "red";
			} else {
				validationErrors.deal_name = "";
				document.querySelector(".deal-name").style.borderColor = "";
			}
		}

		if (name === "deal_description") {
			if (value.trim().length > 500) {
				validationErrors.deal_description = "Deal Description Exceeds 500 Characters.";
				document.querySelector(".deal-description").style.borderColor = "red";
			} else {
				validationErrors.deal_description = "";
				document.querySelector(".deal-description").style.borderColor = "";
			}
		}

		setError(validationErrors);

		// If any error exists, return early
		if (hasError || Object.values(validationErrors).some((error) => error !== "")) {
			return;
		}
	};


	const handleInputChange = (index, event) => {
		const { name, value } = event.target;
		const updatedRows = [...rows];
		let formattedValue = value;

		if (name === "milestone_amount") {
			// Prevent non-numeric characters except a single dot
			formattedValue = formattedValue.replace(/[^0-9.]/g, '');

			// Ensure only one dot is present
			const parts = formattedValue.split('.');
			if (parts.length > 2) {
				formattedValue = parts[0] + '.' + parts.slice(1).join('');
			}

			// Restrict to two decimal places
			if (parts.length === 2 && parts[1].length > 2) {
				formattedValue = parts[0] + '.' + parts[1].slice(0, 2);
			}

			// Prevent leading dot (convert ".5" → "0.5")
			if (formattedValue.startsWith('.')) {
				formattedValue = '0' + formattedValue;
			}

			updatedRows[index][name] = formattedValue;
		} else {
			updatedRows[index][name] = value;
		}

		// Update milestone status based on amount change
		if (name === "milestone_amount") {
			if (updatedRows[index]["milestone_amount_temp"] == formattedValue) {
				updatedRows[index]["milestone_status"] = updatedRows[index]["milestone_status_temp"];
			} else {
				updatedRows[index]["milestone_status"] = "Draft";
			}
		}

		let totalMilestoneAmount = updatedRows.reduce((sum, milestone) => {
			return sum + Number(milestone.milestone_amount || 0);
		}, 0);

		let hasError = false;

		// Validate milestone amount
		if (name === "milestone_amount") {
			if (Number(totalMilestoneAmount) === 0 || formattedValue === '') {
				updatedRows[index]["milestone_amount_error"] = "Enter Amount";
				document.querySelector(`.milestone-amount-${index}`).style.borderColor = "red";
				hasError = true;
			} else {
				updatedRows[index]["milestone_amount_error"] = "";
				document.querySelector(`.milestone-amount-${index}`).style.borderColor = "";
			}
		}

		// Validate milestone description
		if (name === "milestone_desc") {
			if (!value.trim()) {
				updatedRows[index]["milestone_desc_error"] = "Enter Description";
				document.querySelector(`.milestone-desc-${index}`).style.borderColor = "red";
				hasError = true;
			} else if (value.trim().length > 500) {
				updatedRows[index]["milestone_desc_error"] = "Description Exceeds 500 Characters.";
				document.querySelector(`.milestone-desc-${index}`).style.borderColor = "red";
				hasError = true;
			} else {
				updatedRows[index]["milestone_desc_error"] = "";
				document.querySelector(`.milestone-desc-${index}`).style.borderColor = "";
			}
		}

		setRows(updatedRows);

		if (hasError) {
			return;
		}
	};

	const changeDealStatus = (value, event) => {
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			["deal_status"]: value, // Update inputValue with the selected values
		}));
	};
	const handleAddRow = () => {
		setRows([
			...rows,
			{
				milestone_sl_no: rows.length + 1,
				milestone_desc: "",
				milestone_amount: "",
				milestone_due: null,
				milestone_status: "Draft",
			},
		]);
	};
	const handleChangeDate = (index, name) => (value) => {
		//console.log(value);
		// console.log(new Date("2023-02-22"));
		if (!value) {
			setRows((prevRows) =>
				prevRows.map((row, rowIndex) => {
					if (rowIndex === index) {
						return { ...row, [name]: "" };
					}
					return row;
				})
			);
			setTepDates((prevTepDates) => ({ ...prevTepDates, [index]: "" }));
		} else {
			const formattedDates = moment(value).format("YYYY-MM-DD");
			setRows((prevRows) =>
				prevRows.map((row, rowIndex) => {
					if (rowIndex === index) {
						// Clear validation error and update the date
						return { ...row, [name]: formattedDates, milestone_due_error: "" };
					}
					return row;
				})
			);
			setTepDates((prevTepDates) => ({ ...prevTepDates, [index]: value }));
			document
				.querySelector(`.milestone-due-${index}`)
				.querySelector('div[name="milestone_due"]').style.borderColor = "";
		}
	};
	const handleRemoveRow = (index) => {
		const updatedRows = [...rows];
		updatedRows.splice(index, 1);
		setRows(updatedRows);
	};
	const editHandler = (index) => {
		setRows((prevRows) =>
			prevRows.map((row, rowIndex) => {
				if (rowIndex === index) {
					return { ...row, isEditable: false }; //milestone_status: "Due",
				}
				return row;
			})
		);
	};
	const handleCancel = () => {
		// Add your cancel logic here
		//console.log("Cancel button clicked!");
		window.parent.location = "/deals/list"; //window.parent.location.href;
	};

	const handleSubmit = async () => {
		const muviUserUuid = Cookies.get("muvi_useruuid");
		/** Deals Validation Part */
		let validationErrors = {};
		let totalAmount;

		if (!inputValue.customer_tattle_uuid) {
			validationErrors.customer_tattle_uuid = "Select Account Name";
			//document.querySelector(".customer-id").querySelector(`.css-yk16xz-control`).style.borderColor = "red";
		} else {
			validationErrors.customer_tattle_uuid = "";
			//document.querySelector(".customer-id").querySelector(`.css-1pahdxg-control`).style.borderColor = "";
		}

		if (inputValue.product.length == 0) {
			validationErrors.product_key = "Select Product Name";
			document.querySelector(`.product-key`).querySelector(`.rs-picker-toggle`).style.borderColor = "red";
		} else {
			validationErrors.product_key = "";
			document.querySelector(`.product-key`).querySelector(`.rs-picker-toggle`).style.borderColor = "";
		}

		if (!inputValue.deal_name.trim()) {
			validationErrors.deal_name = "Enter Deal Name";
			document.querySelector(`.deal-name`).style.borderColor = "red";
		} else if (inputValue.deal_name.length > 100) {
			validationErrors.deal_name = "Deal Name Exceeds 100 Characters.";
			document.querySelector(`.deal-name`).style.borderColor = "red";
		} else {
			validationErrors.deal_name = "";
			document.querySelector(`.deal-name`).style.borderColor = "";
		}

		if (!inputValue.deal_value) {
			validationErrors.deal_value = "Enter Deal Value";
			document.querySelector(`.deal-value`).style.borderColor = "red";
		} else {
			const updatedRows = [...rows];
			let totalMilestoneAmount;
			totalMilestoneAmount = updatedRows.reduce((sum, milestone) => {
				return sum + Number(milestone.milestone_amount);
			}, 0);
			if (totalMilestoneAmount !== Number(inputValue.deal_value)) {
				validationErrors.deal_value = `The Amount should be the same as the sum of all milestone Value and cannot exceed it.`;
				document.querySelector(`.deal-value`).style.borderColor = "red";
			} else {
				validationErrors.deal_value = "";
				document.querySelector(`.deal-value`).style.borderColor = "";
			}
			//validationErrors.deal_value = "";
		}

		if (!inputValue.deal_state.trim()) {
			validationErrors.deal_state = "Select Deal State";
			document.querySelector(`.deal-state`).querySelector(`.rs-picker-toggle`).style.borderColor = "red";
		} else {
			validationErrors.deal_state = "";
			document.querySelector(`.deal-state`).querySelector(`.rs-picker-toggle`).style.borderColor = "";
		}

		/** Milestone Not Available Validation Part */
		if (rows.length === 0) {
			validationErrors.milestone = "You need to add at least one milestone.";
		} else {
			validationErrors.milestone = "";
		}
		/** Milestone Validation Part */
		let hasError = false;

		const updatedRows = rows.map((row, index) => {
			let rowErrors = {};
			if (!row.milestone_desc.trim()) {
				rowErrors.milestone_desc_error = "Enter Description";
				document.querySelector(`.milestone-desc-${index}`).style.borderColor = "red";
				hasError = true;
			} else {
				rowErrors.milestone_desc_error = "";
				document.querySelector(`.milestone-desc-${index}`).style.borderColor = "";
			}
			if (!row.milestone_amount) {
				rowErrors.milestone_amount_error = "Enter Amount";
				document.querySelector(`.milestone-amount-${index}`).style.borderColor = "red";
				hasError = true;
			} else {
				rowErrors.milestone_amount_error = "";
				document.querySelector(`.milestone-amount-${index}`).style.borderColor = "";
			}

			if (!row.milestone_due) {
				rowErrors.milestone_due_error = "Enter Due Date";
				document
					.querySelector(`.milestone-due-${index}`)
					.querySelector('div[name="milestone_due"]').style.borderColor = "red";
				hasError = true;
			} else {
				rowErrors.milestone_due_error = "";
				document
					.querySelector(`.milestone-due-${index}`)
					.querySelector('div[name="milestone_due"]').style.borderColor = "";
			}

			return { ...row, ...rowErrors };
		});

		// Set validation errors
		setError(validationErrors);

		// Update the rows state with validation errors
		setRows(updatedRows);
		// If any error exists, return early
		if (hasError || Object.values(validationErrors).some((error) => error !== "")) {
			return;
		}

		setIsSaving(true);
		// Add your save logic here
		rows.forEach((item) => {
			const dueDate = new Date(item.milestone_due).toLocaleDateString("en-CA"); // Convert to YYYY-MM-DD format
			item.milestone_due = dueDate; // Update the milestone_due
		});

		const requestBody = {
			...inputValue,
			milestone: rows,
			user_uuid: muviUserUuid,
			customer_tattle_uuid: inputValue.customer_tattle_uuid,
		};
		// console.log("Body:", requestBody);
		// return;
		let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/store-deal-data";

		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, requestBody, true);
			//console.log("Response:", responseData);
			//setIsSaving(false);
		} catch (error) {
			console.error("Error:", error);
			setIsSaving(false);
			return;
		}
		if (responseData && responseData.code == 200) {
			setIsSaving(false);
			toast.success(responseData.message, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			setInputValue({
				customer_tattle_uuid: "",
				product: [],
				deal_name: "",
				deal_value: "",
				deal_state: "",
				deal_description: "",
			});
			setRows([]);
			setTimeout(() => {
				history.push("/deals/list");
			}, 200);
		} else {
			setIsSaving(false);
			const errorMessage = responseData && responseData.message ? responseData.message : "An error occurred";
			toast.error(errorMessage, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		}
	};

	const backHandler = () => {
		history.goBack();
	};

	function convertUnixTimeStampToDate(unixTimestamp) {
		if (unixTimestamp) {
			const date = new Date(unixTimestamp).toLocaleDateString("en-CA");
			return date;
		}
	}
	return (
		<div>
			<Header brecum_name="Deals" brecum_page={isEdit ? "Edit Deal" : "Add Deal"} />
			<ToastContainer />

			<div className="right_col">
				<div className="customer-wrap">
					<div className="page-top" style={{ padding: "0px 0px" }}>
						<div className="containerfull title" style={{ padding: "0px 0px" }}>
							<div className="row">
								<div className="col-md-11">
									<div className="row">
										<div className="col-md-6">
											<div className="mt-10">
												<div className="d-flex align-items-center">
													<h2> {isEdit ? "Edit" : "Add"} Deal</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* Serch Box */}
								<div className="col-md-1">
									<div className="d-flex12">
										<div
											className="toogle-btn"
											style={{ float: "right", margin: "5px 5px", height: "37px" }}
											onClick={backHandler}
										>
											<span style={{ fontSize: "18px", lineHeight: "20px", color: "#7a7a7a" }}>
												<BiArrowBack />
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="body-content" style={{ width: "100%", padding: "10px" }}>
						{/* Add New Deal Form */}
						<div className="containerfull">
							<div className="row">
								<div className="col-md-6 col-lg-6">
									<div className="inputGroup">
										<label className="input-label">
											Account Name <span className="star">*</span>
										</label>
								        <Autocomplete
											name="customer_tattle_uuid"
											value={customerSearchValue}
											items={customerData}
											valueProperty="value"
											labelProperty="label"
											isLoading={customerLoading}
											placeholder={"Select Account Name"}
											onSelect={(value, item) => {
												handleCutomerChange(item)
											}}
											onChange={(event, value) => {
												setCustomerSearchValue(value)
											}}
										/>
										{/* {isEdit ? (
											<AsyncSelect
												value={
													inputValue.customer_tattle_uuid
														? customerData.find(
															(item) => item.customer_tattle_uuid === inputValue.customer_tattle_uuid
														)
															? {
																label: customerData.find(
																	(item) =>
																		item.customer_tattle_uuid === inputValue.customer_tattle_uuid
																).company_name,
																value: inputValue.customer_tattle_uuid,
															}
															: {
																label: "",
																value: inputValue.customer_tattle_uuid,
															}
														: null
												}
												// Other props for AsyncSelect
												onChange={handleSelectChange("customer_tattle_uuid")}
												loadOptions={loadOptions}
												placeholder="Select Account Name"
												className="customer_tattle_uuid"
												isDisabled={isDisable && true}
												defaultOptions={true}
												cacheOptions={true}
											/>
										) : (
											<AsyncSelect
												// Name prop for form submission
												name="customer_tattle_uuid"
												onChange={handleSelectChange("customer_tattle_uuid")}
												loadOptions={loadOptions}
												placeholder="Select Account Name"
												className="customer_tattle_uuid"
												isDisabled={isDisable && true}
												defaultOptions={true} // Show options on initial load
												cacheOptions={true} // Cache options
											/>
										)} */}
										{error && <div className="text-danger">{error.customer_tattle_uuid}</div>}
									</div>
								</div>
								<div className="col-md-6 col-lg-6">
									<div className="inputGroup">
										<label className="input-label">
											Product <span className="star">*</span>
										</label>
										<CheckPicker
											data={productData.map((item) => {
												return {
													label: item.product_name,
													value: item.product_key,
												};
											})}
											className="product-key"
											name="product"
											value={inputValue.product}
											onChange={handleSelectChange("product")}
											style={{
												width: "100%",
												zIndex: 1050,
											}}
											block={true}
											searchable={false}
											placeholder="Select Product"
											disabled={isDisable && true}
										/>

										{error && <div className="text-danger">{error.product_key}</div>}
									</div>
								</div>
							</div>
							<div className="row mt20">
								<div className="col-md-6 col-lg-6">
									<div className="inputGroup">
										<label className="input-label">
											Deal Name <span className="star">*</span>
										</label>
										<input
											type="text"
											className="form-control deal-name"
											id="feature"
											autoComplete="off"
											placeholder="Enter Deal Name"
											name="deal_name"
											value={inputValue.deal_name}
											onChange={(event) => handleDealInputChange(event)}
										/>
										{error && <div className="text-danger">{error.deal_name}</div>}
									</div>
								</div>

								<div className="col-md-3 col-lg-3">
									<div className="inputGroup">
										<label className="input-label">
											Deal Value ($) <span className="star">*</span>{" "}
										</label>
										<input
											type="text"
											className="form-control deal-value"
											id="feature"
											autoComplete="off"
											placeholder="Enter Deal Value"
											name="deal_value"
											value={inputValue.deal_value}
											onChange={(event) => handleDealInputChange(event)}
										/>

										{error && <div className="text-danger">{error.deal_value}</div>}
									</div>
								</div>
								<div className="col-md-3 col-lg-3">
									<div className="inputGroup">
										<label className="input-label">
											Deal State <span className="star">*</span>
										</label>
										<SelectPicker
											data={dealStates}
											name="deal_state"
											className="deal-state"
											value={inputValue.deal_state}
											onChange={handleSelectChange("deal_state")}
											style={{
												width: "100%",
												zIndex: 1050,
											}}
											block={true}
											searchable={false}
											placeholder="Select Deal State"
										// onOpen={() => getDealState()}
										// loading={stateLoading}
										/>
										{error && <div className="text-danger">{error.deal_state}</div>}
									</div>
								</div>
							</div>
							<div className="row mt20">
								<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div className="inputGroup">
										<label>Description</label>
										<textarea
											className="form-control deal-description"
											id="exampleFormControlTextarea1"
											rows="3"
											autoComplete="off"
											placeholder="Enter Description"
											name="deal_description"
											value={inputValue.deal_description}
											onChange={(event) => handleDealInputChange(event)}
										></textarea>
										{error && <div className="text-danger">{error.deal_description}</div>}
									</div>
								</div>
							</div>
						</div>

						{/* Milestone */}
						<div className="containerfull mt20">
							<div className="informationTitle" style={styleObj.informationTitle}>
								Payment Schedule
							</div>
							{error && <div className="text-danger">{error.milestone_amount_total_error}</div>}
							<div className="table-wrap table-milestone">
								<table
									className="deal-table"
									style={{
										tableLayout: "fixed",
										borderCollapse: "separate",
										borderSpacing: "0 10px",
										width: "100%",
										minWidth: 0,
									}}
								>
									<thead>
										<tr>
											<th style={styleObj.intra_col_7}>Milestone</th>
											<th style={styleObj.intra_col_15}>Description</th>
											<th style={styleObj.intra_col_15}>Amount ($)</th>
											<th style={styleObj.intra_col_10}>Due Date</th>
											<th style={styleObj.intra_col_10}>Payment Status</th>
										</tr>
									</thead>
									<tbody>
										{rows.map((row, index) => (
											<tr key={row.milestone_sl_no}>
												<td style={{ borderRight: "none" }}>{row.milestone_sl_no}</td>
												<td style={{ borderRight: "none", borderLeft: "none" }}>
													<input
														type="text"
														className={`form-control milestone-desc-${index}`}
														id="feature"
														autoComplete="off"
														placeholder="Enter Description"
														name="milestone_desc"
														value={row.milestone_desc}
														onChange={(event) => handleInputChange(index, event)}
														disabled={row.isEditable && true}
													/>
													{row && (
														<div className="text-danger">{row.milestone_desc_error}</div>
													)}
												</td>
												<td style={{ borderRight: "none", borderLeft: "none" }}>
													<input
														type="text"
														className={`form-control milestone-amount-${index}`}
														id="feature"
														autoComplete="off"
														placeholder="Enter Amount"
														name="milestone_amount"
														value={row.milestone_amount}
														onChange={(event) => handleInputChange(index, event)}
														disabled={row.isEditable && true}
													/>
													{row && (
														<div className="text-danger">{row.milestone_amount_error}</div>
													)}
												</td>

												<td style={{ borderRight: "none", borderLeft: "none" }}>
													<div className="inputGroup">
														<DatePicker
															className={`milestone-due-${index}`}
															name="milestone_due"
															value={
																tepDates[index] ||
																(row.milestone_due && row.milestone_due)
															}
															onChange={handleChangeDate(index, "milestone_due")}
															disabled={row.isEditable && true}
															oneTap
														/>
														{row && (
															<div className="text-danger">{row.milestone_due_error}</div>
														)}
													</div>
												</td>
												<td
													style={{
														borderLeft: "none",
													}}
												>
													<div
														style={{
															display: "flex",
															flexDirection: "row",
															justifyContent: "space-between",
															alignItems: "center",
														}}
													>
														{row.milestone_status ? (
															row.milestone_status === "Paid" ? (
																<p className="bagde-customer">Paid</p>
															) : row.milestone_status === "Due" ? (
																new Date(currentUnixTime) >
																	new Date(
																		convertUnixTimeStampToDate(row.milestone_due)
																	) ? (
																	<p className="bagde-danger">Overdue</p>
																) : (
																	<p className="bagde-warning">Due</p>
																)
															) : row.milestone_status == "Lost" ? (
																<p className="bagde-internal">Lost</p>
															) : (
																<p className="badge-yellow">Draft</p>
															)
														) : (
															""
														)}
														{/* <BiX style={{ fontSize: "18px", marginRight: "10px", float: "right" }} /> */}
														{isEdit &&
															(row.milestone_status == "Draft" ||
																row.milestone_status == "Overdue" ||
																row.milestone_status == "Due") && (
																<span style={{ float: "right" }}>
																	<BiPencil
																		style={{
																			fontSize: "18px",
																			marginRight: "10px",
																		}}
																		onClick={() => editHandler(index)}
																	/>
																	<BiTrash
																		style={{
																			fontSize: "18px",
																			marginRight: "10px",
																		}}
																		onClick={() => handleRemoveRow(index)}
																	/>
																</span>
															)}

														{!isEdit && (
															<span style={{ float: "right" }}>
																<BiTrash
																	style={{ fontSize: "18px", marginRight: "10px" }}
																	onClick={() => handleRemoveRow(index)}
																/>
															</span>
														)}
													</div>
												</td>
											</tr>
										))}
										{error && error.milestone ? (
											<tr>
												<td colSpan={5}>
													{error && <div className="text-danger">{error.milestone}</div>}
												</td>
											</tr>
										) : (
											""
										)}
									</tbody>
								</table>
								<div
									className="d-flex"
									style={{
										padding: "1rem .5rem",
										color: "#1675e0",
										fontSize: "11px",
										fontWeight: "500",
										cursor: "pointer",
										width: "fit-content",
									}}
									onClick={handleAddRow}
								>
									<BiPlus style={{ fontSize: "16px" }} /> Add More Milestone
								</div>
							</div>
						</div>

						<div className="row mt20">
							<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								{isEdit && (
									<div className="addFeatureBtn-Group" style={{ float: "left" }}>
										<label className="input-label">Deal Status &nbsp;</label>

										<Toggle
											size="md"
											checkedChildren="Open"
											unCheckedChildren="Close"
											checked={inputValue.deal_status}
											onChange={(value, event) => changeDealStatus(value, event)}
										/>
									</div>
								)}
							</div>
						</div>
						<div className="row mt30">
							<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<div className="addFeatureBtn-Group" style={{ float: "left" }}>
									<button
										type="submit"
										className="btn btn-primary"
										onClick={handleSubmit}
										disabled={isSaving}
									>
										{isSaving ? "Saving..." : "Save"}
									</button>
									<button className="btn btn-blue" onClick={handleCancel}>
										Cancel
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const styleObj = {
	informationTitle: {
		fontWeight: 500,
		fontSize: "14px",
		color: "#333",
		textTransform: "capitalize",
		fontFamily: "Poppins-Medium",
		padding: "10px 0",
	},
	intra_col_5: {
		width: "5%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_7: {
		width: "7%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_10: {
		width: "10%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_15: {
		width: "15%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_20: {
		width: "20%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_2: {
		width: "2%",
	},
};

export default AddDeal;



// WEBPACK FOOTER //
// ./src/components/crm/deals/AddDeal.js